module.exports = __webpack_public_path__ + "img/bobei_bobocoin.gm.cc6ed30.png";